function guests_Reducer(state = [], action) {
    switch (action.type) {
        case 'GUESTS/SET':            
            return action.guests;
        case 'GUESTS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default guests_Reducer;
